const info = [{
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cosmoshub',
            client_id: '07-tendermint-926',
            connection_id: 'connection-648'
        },
        chain_2: {
            chain_name: 'point',
            client_id: '07-tendermint-1',
            connection_id: 'connection-0'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-404',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }];
export default info;
